import React, { useState } from 'react';
import api from '../../api';
import { toastr } from 'react-redux-toastr';
import noImage from './user-noimage.png';
import loadingImage from '../loader/loader.gif';
import './Upload.scss';
import { AvatarImage } from '../render-file/AvatarImage';
import { MediaFile } from '../../core';

const getFileType = (type: string) => {
  switch (type) {
    case 'png':
    case 'jpeg':
      return `image/${type}`;
    case 'jpg':
      return `image/jpeg`;
    default:
      return type;
  }
};

interface CustomProps {
  id: string;
  onChange: (file?: string | any) => void;
  disabled?: boolean;
  title?: string;
  description?: string;
  accept?: string[];
  imageOuterClass?: string;
  imageClass?: string;
  inputOuterClass?: string;
  labelClass?: string;
  default?: MediaFile;
  isPhotoOnly?: boolean;
}

const FileUpload: React.SFC<CustomProps> = (props: CustomProps) => {
  const [uploading, setUploading] = useState(false);
  const [, setProgress] = useState(0);
  const [imageFile, setFile] = useState<MediaFile | undefined>(
    props.default || undefined
  );

  const handleChange = async (selectedFiles?: FileList) => {
    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];

      setUploading(true);
      // setFile(loadingImage);
      try {
        const uploadedResponse = await api.upload.uploadPublicFile(file, onProgress);
        if (props.isPhotoOnly) {
          props.onChange(uploadedResponse?.data?.location);
        } else {
          props.onChange(uploadedResponse?.data);
        }

        setFile(uploadedResponse?.data);
      } catch (error) {
        setFile(undefined);
        if (error?.response?.data?.message) {
          toastr.error('Error', error?.response?.data?.message);
        } else {
          toastr.error('Error', 'File upload failed');
        }
      }
      setUploading(false);
    }
  };

  const onProgress = (event: ProgressEvent) => {
    const progressPercentage = event.loaded / event.total;
    setProgress(progressPercentage);
  };

  return (
    <>
      <div className={props.imageOuterClass || 'avatar position-relative mr-2'}>
        <AvatarImage
          image={imageFile}
          className={props.imageClass || 'img-cover img-fluid rounded-circle'}
        ></AvatarImage>
        {/* <img
          src={imageFile || noImage}
          className={props.imageClass || 'img-cover img-fluid rounded-circle'}
          alt="user image"
        /> */}
        {uploading && (
          <img
            src={loadingImage}
            className="img-cover img-fluid rounded-circle upload-loading"
            alt="user image"
          />
        )}
      </div>
      <div className={props.inputOuterClass || 'pl-1'}>
        <input
          type="file"
          id={props.id}
          onChange={(e) => handleChange(e.target.files || undefined)}
          disabled={uploading}
          hidden
          accept={
            props.accept
              ? props.accept.map((t) => getFileType(t)).join(', ')
              : undefined
          }
          className="d-none"
        />
        <label
          htmlFor={props.id}
          className={
            props.labelClass || 'mb-0 text-primary font-sm font-weight-semibold'
          }
        >
          {props.title}
        </label>
      </div>
    </>
  );
};

export default FileUpload;
